import React from 'react'
import { submitInnerNeedsTest, submitTraitTest } from '../../../redux/tool/toolSlice'

// Test configuration based on test type
export const TEST_CONFIGS = {
  'inner-needs': {
    totalSteps: 4,
    questionsPerStep: 21,
    apiEndpoint: 'inner-needs',
    submitAction: submitInnerNeedsTest,
    title: 'Inner Needs ',
    resultTitle: 'Inner Needs Result',
    categories: {
      Certainty: "Certainty",
      Variety: "Variety",
      Significance: "Significance",
      "Love/Connection": "Love/Connection",
      Growth: "Growth",
      Contribution: "Contribution"
    }
  },
  'traits-test': {
    totalSteps: 5,
    questionsPerStep: 14,
    apiEndpoint: 'traitstest',
    submitAction: submitTraitTest,
    title: 'Character Traits Assessment',
    resultTitle: 'Traits Test Result',
    categories: {
      Openness: "Openness",
      Conscientiousness: "Conscientiousness",
      Extroversion: "Extroversion",
      Agreeableness: "Agreeableness",
      Neurotism: "Neurotism",
      Teamwork: "Teamwork",
      Leadership: "Leadership",
    }
  }
}

// Get test config based on route or test type
export const getTestConfig = (testType) => {
  return TEST_CONFIGS[testType] || TEST_CONFIGS['inner-needs']
}